import { render, staticRenderFns } from "./NewOrderServiceNode.vue?vue&type=template&id=5f4ee545"
import script from "./NewOrderServiceNode.vue?vue&type=script&lang=js"
export * from "./NewOrderServiceNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports